<template>
  <DescriptionList>
    <DescriptionListEntry
      v-for="entry in entries"
      :key="entry.value?.toString()"
    >
      <template #key>
        <DescriptionListKey>
          <Icon :icon="entry.icon" aria-hidden />
          <span class="sr-only">
            {{ entry.label }}
          </span>
        </DescriptionListKey>
      </template>

      <template #values>
        <DescriptionListValue
          v-for="value in wrapToArray(entry.value)"
          :key="value"
        >
          {{ fallback(value) }}
        </DescriptionListValue>
      </template>
    </DescriptionListEntry>
  </DescriptionList>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import { fallback, wrapToArray } from "@/helpers";
import Icon from "@/components/generic/Icon/Icon.component.vue";
import type { IconListEntry } from "./IconListEntry.model";
import DescriptionList from "../DescriptionList/DescriptionList.component.vue";
import DescriptionListEntry from "../DescriptionList/DescriptionListEntry.component.vue";
import DescriptionListKey from "../DescriptionList/DescriptionListKey.component.vue";
import DescriptionListValue from "../DescriptionList/DescriptionListValue.component.vue";

defineProps({
  entries: {
    type: Array as PropType<Array<IconListEntry>>,
    default: () => [],
  },
});
</script>
